import React, { useState } from 'react';
import styled from 'styled-components';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '../Shared/StyledTooltip';
import { TitleContainer, ActionButton, SettingsLabel, OrganisationCheckbox } from './components/AccountDetailsComponents';
import AddEmailContact from './AddEmailContact';

const TOOLTIP =
  'Addresses BCC\'d on the patient\'s "order ready" email. Add your review provider\'s invitation address (e.g. Trustpilot AFS) so it can send patients a review request after their order is ready.';

const ReviewInvitationBccEmails = ({ value = [], onChange }) => {
  const [isAddingEmail, setIsAddingEmail] = useState(false);

  const toggleIsAddingEmail = () => setIsAddingEmail(prevIsAddingEmail => !prevIsAddingEmail);

  const removeEmailHandler = email => checked => {
    if (checked || !window.confirm(`Do you want to delete this email? ${email}`)) return;
    onChange(value.filter(existingEmail => existingEmail !== email));
  };

  const addEmailHandler = email => {
    if (value.includes(email)) return alert(`${email} has already been added`);

    onChange([...value, email]);
    toggleIsAddingEmail();
  };

  return (
    <>
      <SettingsLabel>
        <TitleContainer>Review Invitation BCC Emails</TitleContainer>
        <Tooltip title={TOOLTIP} placement="right">
          <InfoIcon />
        </Tooltip>
        <ActionButton onClick={toggleIsAddingEmail}>{isAddingEmail ? 'Cancel' : 'Add'}</ActionButton>
      </SettingsLabel>
      <Container>
        {isAddingEmail && (
          <AddEmailContact
            placeholder="Add Review Invitation Email"
            onSubmit={addEmailHandler}
            onCancel={toggleIsAddingEmail}
          />
        )}
        {value.map(email => (
          <OrganisationCheckbox checked key={email} onChange={removeEmailHandler(email)}>
            {email}
          </OrganisationCheckbox>
        ))}
      </Container>
    </>
  );
};

const InfoIcon = styled(InfoOutlinedIcon)`
  color: #757575;
  font-size: 20px;
  margin-right: 8px;
  cursor: help;
  vertical-align: middle;
`;

const Container = styled.div`
  overflow-y: auto;
  max-height: 300px;
`;

export default ReviewInvitationBccEmails;
